import * as React from "react";

import Container from "@client/content/Containers/container";
import { getEntityRef } from "@client/content/lib/helper";
import ContentTextStyle from "@client/content/Style/Text";
import { type RootContainerProps } from "@client/content/types";
import WithFilterFluidGrid, { type WithFilterFluidGridProps } from "@client/controls/Grid/Fluid/WithFilter/component";
import ItemContainer, { type PortfolioGalleryItemContainerProps } from "./Item/container";

import "./style.less";

export type PortfolioGalleryComponentMapProps = RootContainerProps &
  Omit<WithFilterFluidGridProps<PortfolioGalleryItemContainerProps>, "ItemComponent" | "onTagClick"> & {};

export interface PortfolioGalleryComponentActionProps {
  onTagClick: (tag: string) => void;
}

export type PortfolioGalleryComponentProps = PortfolioGalleryComponentActionProps & PortfolioGalleryComponentMapProps;
export default ({ className, id, TextComponent, source, viewonly, ...gridProps }: PortfolioGalleryComponentProps) => (
  <Container id={id} className={className} source={source} viewonly={viewonly}>
    <ContentTextStyle
      {...getEntityRef({ id, source })}
      prefix="content.title"
      textSubSelector=".portfolio_item .title"
    />
    <ContentTextStyle
      {...getEntityRef({ id, source })}
      prefix="content.description"
      textSubSelector=".portfolio_item .description"
    />
    <ContentTextStyle {...getEntityRef({ id, source })} prefix="tags" textSubSelector=".grid-filter a" />

    <WithFilterFluidGrid {...gridProps} ItemComponent={ItemContainer} />
  </Container>
);
